import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../api";
import { Reveal, Eyebrow } from "./Reveal";
import { useApp } from "../store";

export const NewsSection = () => {
  const { t, lang } = useApp();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setItems((r.data.items || []).slice(0, 3))).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      id="actualites"
      data-testid="news-section"
      className="relative text-white grain"
      style={{ background: "var(--sec-actualites-bg, #0A1428)" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <Eyebrow>{t("nav_news")}</Eyebrow>
            <h2 data-testid="news-section-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
              {t("news_title")}
            </h2>
          </div>
          <Link
            data-testid="news-all-link"
            to="/actualites"
            className="group inline-flex items-center gap-2 text-sm border border-[var(--accent-soft)]/30 hover:border-[var(--accent)] hover:text-[var(--accent-soft)] text-white/70 px-5 py-2.5 rounded-full transition-colors duration-300"
          >
            {t("news_all")}
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((n, i) => (
            <Reveal key={n.id} delay={i * 0.07}>
              <Link to="/actualites" data-testid={`news-card-${n.id}`} className="group block h-full border border-[var(--accent-soft)]/15 bg-white/[0.03] hover:border-[var(--accent)]/60 hover:-translate-y-1 transition-all duration-500 overflow-hidden">
                {n.image && (
                  <div className="h-44 bg-black/25 flex items-center justify-center">
                    <img src={n.image} alt="" loading="lazy" className="w-full h-full object-contain" />
                  </div>
                )}
                <div className="p-6">
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[var(--accent-soft)]">
                    {new Date(n.created_at).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-US", { day: "numeric", month: "long", year: "numeric" })}
                  </p>
                  <h3 className="mt-2 font-display font-semibold text-xl leading-snug">
                    {lang === "fr" ? n.title_fr : n.title_en || n.title_fr}
                  </h3>
                  <p className="mt-2 text-sm text-white/55 leading-relaxed line-clamp-3">
                    {lang === "fr" ? n.body_fr : n.body_en || n.body_fr}
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
